// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Autocomplete-cls1__bce011b466b9c0ce138e{/*!*/}.Autocomplete-cls2___992b83a98c55a0ae54b{display:flex;grid-gap:8px;gap:8px;padding:8px;cursor:pointer}.Autocomplete-cls2___992b83a98c55a0ae54b.Autocomplete-active__db5c0775cfbe4be1db46{background-color:#afccfc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Autocomplete-cls1__bce011b466b9c0ce138e",
	"cls2": "Autocomplete-cls2___992b83a98c55a0ae54b Autocomplete-cls1__bce011b466b9c0ce138e",
	"active": "Autocomplete-active__db5c0775cfbe4be1db46"
};
export default ___CSS_LOADER_EXPORT___;
